export default __webpack_public_path__ + "470f50992cdf5ba7f281d9470e54994b.png";